import { render, staticRenderFns } from "./SectionAddOrSwapPanel.vue?vue&type=template&id=2ab37a42&"
import script from "./SectionAddOrSwapPanel.vue?vue&type=script&lang=ts&"
export * from "./SectionAddOrSwapPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SectionAddOrSwapPanel.vue?vue&type=style&index=0&id=2ab37a42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports